import { Injectable } from '@angular/core';

import { TransformerInterface } from '@gfe/core/models/entities/entity-visualization-interface';
import { GenericCsvTransformer } from '@gfe/core/models/entities/implementations/generic-csv-transformer';
import { TransformerInfo } from '@gfe/core/models/transformers.model';
import { isNil } from '@gfe/core/utils/shared-utils';

const csvTransformerConverters: Record<
  string,
  (info: TransformerInfo) => TransformerInterface
> = {} as const;

@Injectable({
  providedIn: 'root'
})
export class CsvTransformerRegistryService {
  getTransformerInterface(transformerInfo: TransformerInfo): TransformerInterface {
    const transformerConverter = csvTransformerConverters[transformerInfo.transformer.name];
    if (isNil(transformerConverter)) {
      return new GenericCsvTransformer(transformerInfo);
    }
    return transformerConverter(transformerInfo);
  }
}
